import { CampaignCreationStoreState } from 'modules/campaign-creation/stores/CampaignCreationStore';

/**
 * Determines if the campaign creation state represents a CSV-based campaign.
 *
 * A CSV campaign is identified when:
 * - CSVImportState.csvS3Key is present (CSV file was uploaded)
 * - ATSImportState.atsListId is NOT present (not an ATS list import)
 * - ATSJobDescriptionState.selectedJob.atsJobId is NOT present (not an ATS job)
 *
 * CSV campaigns require the Opening Messages page to generate personalized
 * messages before launch, unlike ATS campaigns which can launch directly.
 *
 * @param state - The campaign creation store state (can be null)
 * @returns true if this is a CSV campaign, false otherwise
 */
export const getIsCSVCampaign = (
  state: CampaignCreationStoreState | null
): boolean => {
  if (!state) {
    return false;
  }

  const hasCSVImport = !!state.CSVImportState?.csvS3Key;
  const hasATSListImport = !!state.ATSImportState?.atsListId;
  const hasATSJobImport = !!state.ATSJobDescriptionState?.selectedJob?.atsJobId;

  return hasCSVImport && !hasATSListImport && !hasATSJobImport;
};
